<template>
  <div class="waiting-dots anim-fade-in_slow">
    <div class="waiting-dots_dot"></div>
    <div class="waiting-dots_dot"></div>
    <div class="waiting-dots_dot"></div>
  </div>
</template>

<script>
export default {
  name: 'LoaderDots',
}
</script>

<style lang="scss">
@import '@/styles/mixins.scss';

.waiting-dots {
  position: relative;
  display: flex;
  width: 100%;
  &_dot {
    @include circle($size: 0.8rem);
    margin: 0 2px;
    background: currentColor;
    animation-timing-function: cubic-bezier(0, 1, 1, 0);
  }
}
.waiting-dots_dot {
  animation: opacityPulse 1s infinite alternate;
}

.waiting-dots_dot:nth-child(2) {
  animation-delay: 0.5s;
}
.waiting-dots_dot:nth-child(3) {
  animation-delay: 1s;
}

@keyframes opacityPulse {
  0% {
    opacity: 0.3;
    transform: scale(0.8);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
